<div class="overlay" [class.open]="showWindow()" (click)="windowClosed.emit()"></div>
<div class="window" [class.open]="showWindow()">
  <div class="win-bar">
    <div class="win-close" (click)="windowClosed.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </div>
    <div class="win-t">{{ windowTitle() }}</div>
    <div style="width:28px"></div>
  </div>
  <div class="win-body">
    <div class="wg" [style.grid-template-columns]="windowItems().length > 4 ? 'repeat(3, 1fr)' : windowItems().length > 2 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'">
      @for (wi of windowItems(); track wi.name) {
        <div class="wi" (click)="windowItemClicked.emit(wi.route)">
          <div class="wi-ic" [ngClass]="wi.gradient" [innerHTML]="port().svgFor(wi.svgIcon, 15)"></div>
          <div>
            <div class="wi-n">{{ wi.name | translate }}</div>
            <div class="wi-d">{{ wi.desc | translate }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- ═══ DOCK (dock mode) ═══ -->
<div class="dock-wrap" [class.hidden]="navMode() !== 'dock'">
  <div class="dock">
    <!-- Dashboard -->
    <div class="di active" (click)="dockWindowOpened.emit({ labelKey: 'Dashboard', key: 'dashboard' })">
      <div class="di-icon g-indigo">
        <span [innerHTML]="dashboardDockSvg()"></span>
      </div>
      <div class="di-dot"></div>
      <div class="di-tip">{{ 'TOPBAR.DASHBOARD' | translate }}</div>
    </div>
    <div class="ds"></div>

    @for (section of menuSections(); track section.label; let idx = $index) {
      <div class="di" (click)="section.routerLink ? navigated.emit(section.routerLink) : dockWindowOpened.emit({ labelKey: section.label, key: section.label })">
        <div class="di-icon" [ngClass]="section.dockGradient || 'g-indigo'">
          <span [innerHTML]="port().svgFor(section.dockSvg, 24)"></span>
        </div>
        <div class="di-dot"></div>
        <div class="di-tip">{{ section.label | translate }}</div>
        @if (section.badge) {
          <div class="di-badge" [class.green]="section.badgeClass === 'nb-n'">{{ section.badge }}</div>
        }
      </div>
      @if (idx === 3 || idx === menuSections().length - 2) {
        <div class="ds"></div>
      }
    }
  </div>
</div>
